import * as React from "react";
import PropTypes from "prop-types";
import Button from "nx-components/Button";
import Dialog from "nx-components/Dialog";
import renderInDestroyableRoot from "nexia_mobile/components/Dialogs/renderInDestroyableRoot";
import { getLanguageSet } from "nx-components/Locales";

const ConfirmationDialog = ({
  cancelButtonText,
  confirmButtonText,
  message,
  onConfirm,
  onCancel,
  onClickBackground,
  onRequestClose,
  open,
  cancelOnBackgroundClick,
  cancelOnRequestClose,
  cancelByDefault,
}) => {
  const localeSet = getLanguageSet();
  const language = localeSet.nexia_mobile.dialogs.ConfirmationDialog;

  cancelButtonText = cancelButtonText || language.defaultCancelText;
  confirmButtonText = confirmButtonText || language.defaultConfirmText;

  let onBackgroundHandler = onClickBackground;
  if (cancelOnBackgroundClick) {
    onBackgroundHandler = () => {
      if (_.isFunction(onClickBackground)) {
        onClickBackground();
      }
      onCancel();
    };
  }

  let onRequestCloseHandler = onRequestClose;
  if (cancelOnRequestClose) {
    onRequestCloseHandler = () => {
      if (_.isFunction(onRequestClose)) {
        onRequestClose();
      }
      onCancel();
    };
  }

  const styles = {
    container: {
      margin: "1em",
      minWidth: "10em",
      whiteSpace: "pre-line",
      maxWidth: "80vw",
      overflow: "hidden",
    },
    buttonWrapper: {
      textAlign: "center",
      marginTop: "1em",
      marginLeft: "1em",
      marginRight: "1em",
    },
    button: {
      margin: "0.2em 0.1em",
    },
  };
  return (
    <Dialog
      open={open}
      onTapBackground={onBackgroundHandler}
      onRequestClose={onRequestCloseHandler}
    >
      <div style={styles.container}>
        {message}
        <div style={styles.buttonWrapper}>
          {cancelByDefault ? (
            <React.Fragment>
              <Button onTap={onConfirm} theme="ghost" style={styles.button}>
                {confirmButtonText}
              </Button>
              <Button onTap={onCancel} style={styles.button}>
                {cancelButtonText}
              </Button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Button onTap={onCancel} theme="ghost" style={styles.button}>
                {cancelButtonText}
              </Button>
              <Button onTap={onConfirm} style={styles.button}>
                {confirmButtonText}
              </Button>
            </React.Fragment>
          )}
        </div>
      </div>
    </Dialog>
  );
};
ConfirmationDialog.propTypes = {
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  message: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClickBackground: PropTypes.func,
  onRequestClose: PropTypes.func,
  open: PropTypes.bool,
  cancelOnBackgroundClick: PropTypes.bool,
  cancelOnRequestClose: PropTypes.bool,
  cancelByDefault: PropTypes.bool,
};
ConfirmationDialog.defaultProps = {
  cancelOnBackgroundClick: true,
  cancelOnRequestClose: true,
};

// This method creates a destroyable <div> to mount the ConfirmationDialog in when
// there's no existing React context, like for a Backbone View.

// Usage:
// showConfirmationDialog({
//   message: "Are you sure?",
//   confirmButtonText: "Yes I'm sure",
//   cancelButtonText: "No way",
//   cancelOnBackgroundClick: false, // Background clicks will not close the dialog
//   cancelOnRequestClose: true, // Pressing Esc or Back (On Android, Win10) will not close the dialog
//   onConfirm: () => { doIt(); }
// });
export function showConfirmationDialog(options, key) {
  renderInDestroyableRoot((destroyRoot) => {
    const dialogProps = { ...options };

    dialogProps.onConfirm = () => {
      destroyRoot();
      if (_.isFunction(options.onConfirm)) {
        options.onConfirm();
      }
    };
    dialogProps.onCancel = () => {
      destroyRoot();
      if (_.isFunction(options.onCancel)) {
        options.onCancel();
      }
    };

    return <ConfirmationDialog {...dialogProps} open />;
  }, key);
}

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/ConfirmationDialog.jsx